import React from 'react';
import {useAtom} from "jotai";
import {modalState} from "../../../states/action";


/**
 AI 번역 보기 버튼

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */

export default function SNBCaptionValidation() {

  const [{modalOn}, setModalOn] = useAtom(modalState);

  return (
    <>
      <button
        type="button"
        className="btn"
        onClick={() => {
          setModalOn({modalOn:modalOn ? modalOn : !modalOn, modalTitle: '자막 검수', modalContentName:'ModalCaptionValidation'})
        }}
      >
      <i className="bi bi-check2-square"></i>
      <span className="hide">자막 검수</span>
      </button>
    </>
  );
}
